<template>
  <div>
    <v-autocomplete
      :value="zone"
      :items="filterZones"
      v-bind="$attrs"
      @change="changedTo"
      ref="select"
      :multiple="multiple !== false"
      :loading="loading"
      :clearable="clearable"
      :label="$i18n.t(label)"
      :rules="rules"
      @click:clear="clear"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div v-if="multiple !== false">
          <div
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            {{ data.item.name }}
            <v-icon
              style="float:right;margin-left:5px;"
              small
              @click="remove(data.item)"
              >mdi-close</v-icon
            >
          </div>
        </div>
        <div v-else>
          <div ripple class="height32">
            <h5 class="text-title">{{ data.item.name }}</h5>
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float:right"
                >mdi-check</v-icon
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import corpService from "@/store/common/module/CorpService";
import { commonMixin } from "@/mixins/common";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "ZoneSelect",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Zone",
    },
    multiple: {
      default: false,
    },
    clearable: {
      default: false,
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class ZoneSelect extends (Vue, Themeable) {
  zone = null;
  loading = true;
  filter = "";
  zoneCreateDialog = false;

  clear() {
    this.filter = "";
    this.zone = null;
    this.$emit("input", null);
  }

  get filterZones() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    const zones = corpService.zones;

    if (filterby == "") {
      return zones;
    } else {
      const fc = zones.filter(function(c) {
        return c.name.toLowerCase().indexOf(filterby) >= 0;
      });
      return fc;
    }
  }

  changedTo(value) {
    this.filter = "";
    if (this.multiple === false) {
      if (value) {
        this.$emit("input", value._id);
        return;
      }
      if (!value) {
        this.$emit("input", null);
      }
    } else {
      const response = [];
      for (let i = 0; i < value.length; i++) {
        response.push(value[i]._id);
      }

      this.$emit("input", response);
      return;
    }
  }

  async init() {
    this.filter = "";
    await corpService.populateZones();
    const zones = corpService.zones;
    if (this.value && this.multiple === false) {
      for (let i = 0; i < zones.length; i++) {
        if (zones[i]._id === this.value) {
          this.zone = zones[i];
          break;
        }
      }
    } else {
      this.zone = [];
      if (this.value != null && Array.isArray(this.value)) {
        for (let i = 0; i < zones.length; i++) {
          if (this.value.filter((e) => e === zones[i]._id).length > 0) {
            this.zone.push(zones[i]);
          }
        }
      }
    }
  }

  async addZone() {
    this.zoneCreateDialog = false;
    await this.init();
    this.changedTo();
    console.log();
  }

  async mounted() {
    await this.init();
    this.loading = false;
  }

  selected(val) {
    if (val != null && val._id != null && this.zone != null) {
      if (Array.isArray(this.zone)) {
        for (let i = 0; i < this.zone.length; i++) {
          if (val._id === this.zone[i]._id) {
            return true;
          }
        }
      } else if (this.zone != null && this.zone._id != undefined) {
        if (val._id === this.zone._id) {
          return true;
        }
      }
    }
    return false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "") {
      this.zone = null;
    }
    await this.init();
  }

  remove(val) {
    if (val != null && val._id != null && this.zone != null) {
      if (Array.isArray(this.zone)) {
        for (let i = 0; i < this.zone.length; i++) {
          if (val._id === this.zone[i]._id) {
            this.zone.splice(i, 1);
          }
        }
      }
    }
    return false;
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
